// extracted by mini-css-extract-plugin
export default {"buttonDownload":"download_buttonDownload__1sctN"};